export default __webpack_public_path__ + "static/media/Alfajor-dulce-de-leche-y-coco.99f85bbf.jpg";